module.exports = __webpack_public_path__ + "img/c0b95da43a4c5b0d953961a864c4564b.png";